// Components
const LitterPuppyListTable = () => import(/* webpackPrefetch: true, webpackChunkName: litter-puppy-list-table"*/'@/app/views/main-view/breeders/components/breeder-litter-list-component/puppy-list-table/puppy-list-table.vue');
const MatingDamSireDetails = () => import(/* webpackPrefetch: true, webpackChunkName: mating-dam-sire-details"*/'@/app/views/main-view/breeders/components/mating-dam-sire-details-container/mating-dam-sire-details-container.vue');

import breedingManagementService from "@/app/services/main/breeder/breeding-management-service.js"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js";
// Constants
import { STATUS_CODES } from "@/app/constants/constants"

export default {
	name: 'BreederLitterListComponent',
	components: {
		LitterPuppyListTable,
		MatingDamSireDetails,
	},
	directive: {},
	filters: {},
	mixins: [
		toastMessageMixins
	],
	props: {},
	data() {
		return {
			isAPILoading: false,
			matingId: null,
			breederSysId: null,

			matingDetails: null,
			matingName: "",
			damDetails: null,
			sireDetails: null,

			prevRoute: "BREEDER DETAILS"
		}
	},
	computed: {},
	watch: {

	},
	async created() {
		if (this.$route.params) {
			
			this.breederSysId = this.$route.params.breederSysId;
			this.matingId = this.$route.params.matingId;
			await this.getDamAndSireMatingDetails();
		}
		if (this.$route.query.from === "mating-details") {
			this.prevRoute = "MATING DETAILS";
		}
	},
	methods: {
		async getDamAndSireMatingDetails() {
			try {
				this.isAPILoading = true;
				const matingDetailsResponse =
					await breedingManagementService.getAdminDamAndSireMatingDetails(
						this.breederSysId,
						this.matingId
					);

				if (matingDetailsResponse.status === STATUS_CODES.SUCCESS) {
					const { data: matingDetails } = matingDetailsResponse;

					this.damDetails = matingDetails.damDetails;
					this.sireDetails = matingDetails.sireDetails;
					this.matingName = matingDetails.alias;
					this.matingDetails = matingDetails;
				} else {
					const { ERROR_GET_MATING_DETAILS } =
						this.toastMessages.mating();
					this.showAPIErrorToast(
						ERROR_GET_MATING_DETAILS,
						matingDetailsResponse
					);
				}
			} catch (err) {
				this.showGenericErrorToast();
			} finally {
				this.isAPILoading = false;
			}
		},
		hasImageUrl(source) {
			if (!source) {
				return require('@/assets/images/_shared/dog-purchase.png');
			}

			return source;
		},
	}
}